import { mapState } from 'vuex';
import { DelayLoader } from '@/helpers';

export default resourceName => ({
    data() {
        return {
            pagination: {
                showSizeChanger: true,
                pageSizeOptions: ['10', '25', '50', '100'],
            },
            loadingType: 'loading',
            filters: {},
            extraFilters: {},
            sort: null,
            loader: null,
        };
    },
    computed: {
        ...mapState({
            [resourceName]: state => state[resourceName + 'Table'].resources,
        }),
        loading() {
            return this.loader[this.loadingType];
        },
    },
    methods: {
        /**
         * Dispatches to the store to retrieve the resource for
         * the current state the table is in and enables/disables loading
         */
        fetchResources({ pagination, filters, sort }) {
            this.loader.start();

            if (filters) {
                this.filters = filters;
            }

            if (sort) {
                this.sort = sort;
            }

            return this.$store
                .dispatch(`${resourceName}Table/fetch`, {
                    filters: { ...this.filters, ...this.extraFilters },
                    pagination: { ...pagination, ...this.pagination },
                    sort: this.sort,
                })
                .then(this.setPagination)
                .finally(() => this.loader.reset());
        },
        /**
         * Sets the pagination data of locale state
         */
        setPagination({ total, currentPage }) {
            this.pagination = {
                ...this.pagination,
                total,
                current: currentPage,
            };
        },

        setLoadingTypeToProcessing() {
            this.loadingType = 'processing';
        },
    },
    created() {
        // If we already have resources increase the delay so we don't see the loader
        // If we don't do this, when we navigate back and already fetched them we will see rows
        // and no loader for 400ms and then a loader again which feels weird.
        this.loader = new DelayLoader({ delay: this[resourceName].length > 0 ? 5000 : 400 });
        this.fetchResources({})
            /**
             * When the component is created the first load is delayed,
             * so when navigating back you can click another row without being bothered by the loader
             * but filtering and pagination will now use the non delayed loader so the application feels "snappier"
             */
            .then(this.setLoadingTypeToProcessing);
    },
});
